<mat-tab-group
  class="notepad-editor-tabs"
  mat-align-tabs="start"
  [disablePagination]="true"
  [selectedIndex]="selectedTab()"
  (selectedIndexChange)="selectedIndexChange.emit($event)"
>
  @if (showComments()) {
    <mat-tab ariaLabel="Comments">
      <ng-template mat-tab-label>
        <fa-icon [icon]="faComment" matTooltip="Comments" matTooltipPosition="left"></fa-icon>
      </ng-template>

      <ng-content select="[slot=comments]"></ng-content>
    </mat-tab>
  }

  <mat-tab ariaLabel="Preview">
    <ng-template mat-tab-label>
      <fa-icon [icon]="faEye" matTooltip="Preview" matTooltipPosition="left"></fa-icon>
    </ng-template>

    <ng-content select="[slot=preview]"></ng-content>
  </mat-tab>
</mat-tab-group>
